import React from "react";
import { useTranslation } from "next-i18next";

function ContactUsBtn() {
  const { t: translate } = useTranslation("about");
  return (
    <a
      href={`/#contact`}
      className="bg-blue text-white px-9 py-4 font-bold text-sm lg:text-lg rounded-md self-start"
    >
      <button type="button">{translate("join_us")}</button>
    </a>
  );
}

export default ContactUsBtn;
